export default __webpack_public_path__ + "static/media/car3.2b911319.jpg";